/*
*   Shared UI Components JavaScript
*   Common functionality used across all themes and projects
*/

$(document).ready(function() {
    // Initialize Foundation - REQUIRED for accordions, dropdowns, tabs, off-canvas, etc.
    $(document).foundation();

    /*
    * Header functionality - shared across all themes
    */

    // Initialize: Remove dropdown children from tab order when closed
    $('.menu-item-has-children ul a').attr('tabindex', '-1');

    // Search toggle functionality
    $('.mag-glass').click(function() {
        $(this).toggleClass('active');
        $(this).closest('.inner').toggleClass('active');
        $('.search-form').toggleClass('active');
        return false;
    });

    // 12043 — a dropdown parent may carry a real destination (navFolderLink): those parents
    // must NAVIGATE, not just toggle. Unlinked parents keep href="#" and only toggle.
    function hasRealHref($link) {
        var href = $link.attr('href');
        return !!href && href !== '#' && href.indexOf('javascript:') !== 0;
    }

    // Desktop = the same "large" breakpoint the CSS hover-open rule uses (_header.scss),
    // so click never needs to open the submenu there — hover already has.
    function isDesktopNav() {
        if (window.Foundation && Foundation.MediaQuery && typeof Foundation.MediaQuery.atLeast === 'function') {
            return Foundation.MediaQuery.atLeast('large');
        }
        return window.matchMedia('(min-width: 64em)').matches;
    }

    // Dropdown menu functionality - click handler
    $('.menu-item-has-children > a').on('click', function(e) {
        var $link = $(this);
        // Linked parent: desktop click follows the link (hover opens the menu); on smaller
        // screens the first tap opens the submenu and a second tap, while open, follows it.
        if (hasRealHref($link) && (isDesktopNav() || $link.parent().hasClass('active'))) {
            return;
        }
        e.preventDefault();
        toggleDropdown($link);
    });

    // Dropdown menu - keyboard support for accessibility
    $('.menu-item-has-children > a').on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            // Enter on a linked parent keeps native anchor behaviour (navigates);
            // Space always toggles, as does Enter on an unlinked parent.
            if (e.key === 'Enter' && hasRealHref($(this))) {
                return;
            }
            e.preventDefault();
            toggleDropdown($(this));
        }
        // Arrow down to open and focus first item
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            var $parent = $(this).parent();
            if (!$parent.hasClass('active')) {
                toggleDropdown($(this));
            }
            $parent.find('ul li:first-child a').focus();
        }
    });

    // Escape key closes all dropdowns and returns focus to parent
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            var $activeDropdown = $('.menu-item-has-children.active');
            if ($activeDropdown.length) {
                $activeDropdown.find('ul a').attr('tabindex', '-1');
                $activeDropdown.removeClass('active')
                    .find('> a').attr('aria-expanded', 'false').focus();
            }
        }
    });

    // Helper function to toggle dropdown
    function toggleDropdown($link) {
        var $parent = $link.parent();
        var isOpen = $parent.hasClass('active');

        // Close other dropdowns first and remove from tab order
        $parent.siblings('.menu-item-has-children')
            .removeClass('active')
            .find('> a').attr('aria-expanded', 'false')
            .end().find('ul a').attr('tabindex', '-1');

        // Toggle current dropdown
        $parent.toggleClass('active');
        $link.attr('aria-expanded', !isOpen);

        // Update tabindex for dropdown children
        if (!isOpen) {
            // Opening: add to tab order
            $parent.find('ul a').attr('tabindex', '0');
        } else {
            // Closing: remove from tab order
            $parent.find('ul a').attr('tabindex', '-1');
        }
    }

    /*
    * Video player thumbnail overlay
    * Clicking the overlay hides it and triggers iframe autoplay
    */
    $('.video-thumbnail-overlay').on('click', function() {
        var $overlay = $(this);
        var embedUrl = $overlay.data('embed-url');
        var $iframe = $overlay.siblings('iframe');
        if (embedUrl && $iframe.length) {
            var separator = embedUrl.indexOf('?') > -1 ? '&' : '?';
            $iframe.attr('src', embedUrl + separator + 'autoplay=1');
        }
        $overlay.fadeOut(200, function() { $overlay.remove(); });
    });

    /*
    * Mobile menu functionality - shared across all themes
    */
    $('#menu-toggle').on('change', function () {
        if ($(this).is(':checked')) {
            $('.main-menu').addClass('open').css('max-height', $('.main-menu')[0].scrollHeight + '2px');
            $(this).closest('.inner').addClass('active');
            $('body').addClass('menu-open');
        } else {
            $('.main-menu').css('max-height', '0');
            $(this).closest('.inner').removeClass('active');
            $('body').removeClass('menu-open');
            // Wait for transition to complete before removing class (avoids abrupt disappearance)
            setTimeout(() => {
                $('.main-menu').removeClass('open');
            }, 300); // Matches transition duration in CSS
        }
    });
});